import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=498296b2&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"
import style0 from "./RightSidebar.vue?vue&type=style&index=0&id=498296b2&prod&lang=scss&scoped=true"
import style1 from "./RightSidebar.vue?vue&type=style&index=1&id=498296b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498296b2",
  null
  
)

export default component.exports